import { type MyJFrogWindow } from "@shared/types/global";

export default window as unknown as MyJFrogWindow;
